import PropTypes from "prop-types";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";

/**
 * EngagementBadge
 *
 * Displays a vsAvg ratio with colour coding:
 *   > 1.2×  → green  (above average)
 *   0.8–1.2× → grey   (near average)
 *   < 0.8×  → amber  (below average)
 *
 * Returns null when vsAvg is null/undefined — cards without a ratio
 * simply show nothing rather than a broken badge.
 *
 * Props:
 *   vsAvg — number | null
 */
function EngagementBadge({ vsAvg }) {
  if (vsAvg == null) return null;

  const label = `${vsAvg.toFixed(1)}×`;

  let bg, color;
  if (vsAvg > 1.2) {
    bg = "rgba(34,197,94,0.18)";
    color = "#4ade80"; // green-400
  } else if (vsAvg < 0.8) {
    bg = "rgba(251,191,36,0.18)";
    color = "#fbbf24"; // amber-400
  } else {
    bg = "rgba(255,255,255,0.10)";
    color = "rgba(255,255,255,0.5)";
  }

  return (
    <VuiBox
      sx={{
        px: 0.875,
        py: 0.15,
        borderRadius: "5px",
        background: bg,
        display: "inline-flex",
        alignItems: "center",
        flexShrink: 0,
      }}
    >
      <VuiTypography
        variant="caption"
        sx={{ fontSize: "0.68rem", color, fontWeight: "700", lineHeight: 1 }}
      >
        {label}
      </VuiTypography>
    </VuiBox>
  );
}

EngagementBadge.propTypes = {
  vsAvg: PropTypes.number,
};

EngagementBadge.defaultProps = {
  vsAvg: null,
};

export default EngagementBadge;
